var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcedureManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 3.00012H13.4989C13.8967 3.00012 14.2782 3.15817 14.5595 3.43949C14.8408 3.72082 14.9988 4.10238 14.9988 4.50024V15.0011C14.9988 15.3989 14.8408 15.7805 14.5595 16.0618C14.2782 16.3432 13.8967 16.5012 13.4989 16.5012H4.49985C4.10206 16.5012 3.72057 16.3432 3.4393 16.0618C3.15802 15.7805 3 15.3989 3 15.0011V4.50024C3 4.10238 3.15802 3.72082 3.4393 3.43949C3.72057 3.15817 4.10206 3.00012 4.49985 3.00012H5.9997M6.74962 1.5H11.2492C11.6633 1.5 11.9991 1.83581 11.9991 2.25006V3.75018C11.9991 4.16443 11.6633 4.50024 11.2492 4.50024H6.74962C6.33545 4.50024 5.9997 4.16443 5.9997 3.75018V2.25006C5.9997 1.83581 6.33545 1.5 6.74962 1.5Z",
    stroke: "#6A7282",
    strokeWidth: 1.13,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedureManagement);
export default __webpack_public_path__ + "static/media/ProcedureManagement.7e5a58d31885b389779b544952e85489.svg";
export { ForwardRef as ReactComponent };